<template>
    <ul id="galleriFilterBar" :aria-label="$texts.aktivaFilter">
        <li v-for="(tag, index) in currentTags" :key="index" class="filterItem">   
            <button @click="removeFilterItem(tag)">
                <span class="visually-hidden">{{ this.$texts.rensaFilterval }}</span>
                <span class="filterItemText">{{ findName(tag) }}</span>
                <Icon :type="'plus-thin'"></Icon>
            </button>
        </li>
    </ul>
</template>

<script>
import Icon from "common/js/vue/image/icon.vue";

export default {
    name: "GalleriFilterBar",
    props: {
        filtersCombined: Array,
        currentTags: Array
    },
    components: {
        Icon
    },
    data: function () {
        return {
            values: []
        }
    },
    inject: {
        updateUrl: "updateUrl"
    },
    methods: {
        findName(tag) {
            const item = this.filtersCombined.find(i => _.isEqual(i.tag, tag));
            return item["fullNamn"] ?? item["namn"];
        },
        removeFilterItem(tag) {
            let checkbox = document.querySelector(`input[value="${tag}"]`);
            checkbox.click();
        }
    }
}
</script>
